import {css, useTheme} from "@emotion/react";
import {EnvelopIcon, PhoneNotAnsweredIcon, PhoneRingingIcon} from "@web2/ap-icons";
import {dateTimeFormat, formatDate, phoneNumberFormat, secondsFormat} from "@web2/string_utils";

import {IAPTheme} from "../../app/ap_client";
import {df, fai_center, fd_row} from "../../app/styles/flexbox";
import {fwb, mb_lg, mb_sm, mb_xl, mb_xxl} from "../../app/styles/helpers";
import {ApplicationCallStatus, ApplicationSourceGroup} from "../reducers/applications_list_reducer";

enum APApplicationPhoneType {
    ANONYMOUS = "anonymous"
}

export interface IProps {
    application: {
        agent_name: string | null;
        call_start: string | null;
        call_status: ApplicationCallStatus;
        call_time: number | null;
        create_date: string;
        email: string | null;
        name: string | null;
        offer_city: string;
        offer_url: string;
        phone: string | null;
        receiver_phone: string | null;
        source: number;
        source_group: ApplicationSourceGroup;
        text: string | null;
    };
}

export const ApplicationListItem = (props: IProps) => {
    const {application} = props;
    const theme = useTheme();

    return (
        <div css={applicationListItem}>
            <h2 css={dateListTitle}>
                {application.source_group === ApplicationSourceGroup.FORM_APPLICATION ? (
                    <>
                        <EnvelopIcon size="3" css={headingIcon} fillColor={theme.colors.brand_primary} /> Zgłoszenie od klienta GetHome.pl z dnia -{" "}
                        {formatDate(application.create_date, dateTimeFormat.shortDate)}
                    </>
                ) : application.call_status === ApplicationCallStatus.APPLICATION_CALL_STATUS_ANSWERED ? (
                    <>
                        <PhoneRingingIcon size="3" css={headingIcon} fillColor={theme.colors.brand_primary} /> Odebrane połączenie od klienta GetHome.pl z dnia
                        - {formatDate(application.create_date, dateTimeFormat.shortDate)}
                    </>
                ) : (
                    <>
                        <PhoneNotAnsweredIcon size="3" css={headingIcon} fillColor={theme.colors.brand_primary} /> Nieodebrane połączenie od klienta GetHome.pl
                        z dnia - {formatDate(application.create_date, dateTimeFormat.shortDate)}
                    </>
                )}
            </h2>

            <div css={[mb_sm, fwb]}>Dane zgłoszenia:</div>

            {application.source_group === ApplicationSourceGroup.PHONE_APPLICATION ? (
                <>
                    <div css={[mb_sm]}>Godzina połaczenia: {formatDate(application.call_start, dateTimeFormat.longDateTime)}</div>

                    {/*{application.call_time && <div css={[mb_sm]}>Długość rozmowy: {secondsFormat(application.call_time)}</div>}*/}
                </>
            ) : (
                <div css={[mb_sm]}>Data zgłoszenia: {formatDate(application.create_date, dateTimeFormat.shortDateTime)}</div>
            )}

            <div css={[mb_sm]}>Zgłoszenie otrzymał: {application.agent_name ? application.agent_name : "-"}</div>

            {application.receiver_phone && <div css={[mb_sm]}>Telefon: {phoneNumberFormat(application.receiver_phone)}</div>}

            <div css={[mb_sm]}>Miasto: {application.offer_city ? application.offer_city : "-"}</div>

            {application.offer_url && (
                <div css={[mb_xxl]}>
                    Oferta: <a href={application.offer_url}>{application.offer_url}</a>
                </div>
            )}

            <div css={[mb_sm, fwb]}>Dane klienta:</div>

            {application.name && (
                <div css={[mb_sm]}>
                    {application.source === 2 ? (
                        <div css={[mb_sm, df, fd_row, fai_center]}>Telefon: {phoneNumberFormat(application.name)}</div>
                    ) : (
                        <div css={[mb_sm, df, fd_row, fai_center]}>Imię i nazwisko: {application.name}</div>
                    )}
                </div>
            )}

            {application.phone && application.source !== 2 && (
                <div css={[mb_sm]}>
                    Telefon: {application.phone === APApplicationPhoneType.ANONYMOUS ? "Numer zastrzeżony" : phoneNumberFormat(application.phone)}
                </div>
            )}

            {application.email && (
                <div css={[mb_sm]}>
                    Adres e-mail: <a href={`mailto:${application.email}`}>{application.email}</a>
                </div>
            )}

            {application.text && <div css={[mb_xl]}>Treść zgłoszenia: {application.text}</div>}

            {!application.call_time && application.phone !== APApplicationPhoneType.ANONYMOUS && (
                <div css={[mb_lg]}>Prosimy o szybki kontakt z klientem. Zespół Gethome.pl!</div>
            )}
        </div>
    );
};

const applicationListItem = (theme: IAPTheme) => css`
    padding: 1.5rem 0;
    border-bottom: 1px solid ${theme.colors.gray_light};
`;

const dateListTitle = (theme: IAPTheme) => css`
    margin: 1.5rem 0 2rem;
    font-size: 1.8rem;
    font-weight: 600;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${theme.colors.brand_primary};
`;

const headingIcon = css`
    position: relative;
    left: 1rem;
    margin-right: 3rem;
`;
